import LoadingCircle from "reports/components/simple/LoadingCircle";
import EOSReport from "../../../../components/Reports/EOSReport";
import { isEmpty } from "lodash";
import MetricAndPnLBreakdowns from "../../../../components/Reports/GenericCharts/MetricAndPnLBreakdowns/MetricAndPnLBreakdowns";
import {
  useIs24Hours,
  useIsWeekly,
  useProcessGroupNameAndMachemetryIds,
} from "../../../../components/Reports/reportUtils";
import PnLChart from "../../../../components/Reports/GenericCharts/PnLChart/PnLChart";
import { getPnlTimesWithProducingLosses } from "../../../../components/Reports/GenericCharts/PnLChart/pnlChartUtils";
import useEosData from "reports/store/useEosData";
import { MetricEnum } from "reports/utils/metricTypes";
import EccomfglangleySummaryMetrics from "./EccomfglangleySummaryMetrics";
import { ShiftPnlBreakdowns } from "reports/components/Reports/GenericCharts/MetricAndPnLBreakdowns/ShiftPnlBreakdowns";
import { useReportConfig } from "components/DataGetter/FlightConfig/useFlightConfig";

export default function EccomfglangleyEOS() {
  const { processGroupName, machemetryIds } =
    useProcessGroupNameAndMachemetryIds({ defaultProcessGroupName: "All" });

  // EOS needs ge and lt url params, sample is August 26, 2022, 7AM - 3PM
  const sampleLink = `/${processGroupName}?ge=1661522400000&lt=1661551200000`;

  const is24Hour = useIs24Hours();
  const isWeekly = useIsWeekly();
  const shouldShowShiftBreakdown = is24Hour || isWeekly;

  return (
    <>
      {machemetryIds && machemetryIds.length > 0 ? (
        <EOSReport
          machemetryIds={machemetryIds}
          sampleLink={sampleLink}
          flightTimelineLinkGroup={processGroupName}
          flightDashboardLinkGroup={processGroupName}
          shouldShowPrint={false}
          shouldSkipSkuData={false}
          shouldFetchDataByShift={shouldShowShiftBreakdown}
        >
          <EccomfglangleyEosComponents
            {...{
              processGroupName,
              machemetryIds,
              shouldShowShiftBreakdown,
            }}
          />
        </EOSReport>
      ) : (
        <LoadingCircle
          logAfterTimeout={{
            logData: { machemetryIds },
            delay: 5 * 1000,
          }}
        />
      )}
    </>
  );
}

function EccomfglangleyEosComponents({
  processGroupName,
  machemetryIds,
  shouldShowShiftBreakdown,
}) {
  const { data } = useEosData();
  const reportConfig = useReportConfig();
  const summaryMetricsInputList = reportConfig?.eosReportMetricsConfig
    ?.summaryMetricsInputList ?? [
    { name: MetricEnum.OEE },
    { name: MetricEnum.AVAIL },
    { name: MetricEnum.PERF },
    { name: MetricEnum.COUNT, title: "Net Pipes" },
  ];

  return data && !isEmpty(data) && machemetryIds && machemetryIds.length > 0 ? (
    <>
      <EccomfglangleySummaryMetrics {...{ data, processGroupName }} />
      <PnLChart
        pnlTimes={getPnlTimesWithProducingLosses({
          data,
        })}
      />
      {shouldShowShiftBreakdown && (
        <ShiftPnlBreakdowns summaryMetricsInputList={summaryMetricsInputList} />
      )}
      <MetricAndPnLBreakdowns {...{ machemetryIds, summaryMetricsInputList }} />
    </>
  ) : (
    <LoadingCircle
      logAfterTimeout={{
        logData: { eosData: data, machemetryIds },
        delay: 5 * 1000,
      }}
    />
  );
}
